import React from "react";
import { Box, capitalize, CardContent, Typography } from "@mui/material";
import "./AboutSection.css";
// import '../RT/RecruitmentSection.css';

// import Images from "../../constant/images";
import Card from "../../components/Elements/Card/Card";
import Icon from "../../components/Elements/Icon/Icon";
import images from "../../constant/images";

export const OverlappingDesign = () => {
  const categories=[  {
    id: 1,
    title: "Finance & Administrative Management",
    image: images.Finance,
  },
  {
    id: 2,
    title: "Hospitality & Tourism",
    image: images.Hospitality,
  },
  {
    id: 3,
    title: "Healthcare",
    image: images.Healthcare,
  },
  {
    id: 4,
    title: "Contracting & Engineering",
    image: images.Engineering,
  },
  {
    id: 5,
    title: "Manufacturing",
    image: images.Manufacturing,
  },
  {
    id: 6,
    title: "Logistics & Transport",
    image: images.Logistics,
  },
  {
    id: 7,
    title: "IT & Telecom",
    image: images.Telecom,
  },
  {
    id: 8,
    title: "Retail",
    image: images.Retail,
  },
  {
    id: 9,
    title: "Oil & Gas",
    image: images.oil,
  },
  {
    id: 10,
    title: "Food",
    image: images.foodimg,
  },
]
  const categoriestop = [
    {
      id: 1,
      title: "Finance & Administrative Management",
      image: images.Finance,
    },
    {
      id: 2,
      title: "Hospitality & Tourism",
      image: images.Hospitality,
    },
  ];
  const categoriesmid = [
    {
      id: 1,
      title: "Healthcare",
      image: images.Healthcare,
    },
    {
      id: 2,
      title: "Contracting & Engineering",
      image: images.Engineering,
    },
    {
      id: 3,
      title: "Manufacturing",
      image: images.Manufacturing,
    },
    {
      id: 4,
      title: "Logistics & Transport",
      image: images.Logistics,
    },
  ];
  const categorieslast = [
    {
      id: 1,
      title: "IT & Telecom",
      image: images.Telecom,
    },
    {
      id: 2,
      title: "Retail",
      image: images.Retail,
    },
    {
      id: 3,
      title: "Oil & Gas",
      image: images.oil,
    },
    {
      id: 4,
      title: "Food",
      image: images.foodimg,
    },
  ];
  return (
    <>
      <Box className="about-section-container">
        <Box  className="mrss">
       
        <Box className="background-content">
          <Box >
            <Typography
              variant="h6"
              className="card-hadiing"
              textTransform={"capitalize"}
              color="white"
            >
              Industries We Serve{" "}
            </Typography>
            <Typography variant="body1" className="card-body"               color="white"
            >
              We offer consultancy services and human resource solutions  in
            </Typography>
            <Typography variant="body1" className="card-body"               color="white"
            >

             the following specialties.
            </Typography>
          </Box>
        </Box>
        <Box className="left-container">
          {categoriestop.map((category) => (
            <Card className="category1-card" title="">
              <Box className="image-container">
                <Icon
                  className="categorys-image"
                  src={category.image}
                  alt="Vision"
                />
                <Box className="text-overlay">
                  <Typography variant="body1" className="category-title">
                    {category.title}{" "}
                  </Typography>
                </Box>
              </Box>
            </Card>
          ))}
        </Box>
        </Box>



        {/*  */}
        <Box className="center-container">
          {categoriesmid.map((category) => (
            <Card className="categorys-card" title="">
              <Box className="image-container">
                <Icon
                  className="categorys-image"
                  src={category.image}
                  alt="Vision"
                />
                <Box className="text-overlay">
                  <Typography
                    variant="body1"
                    className="category-title"
                    padding={"10px"}
                  >
                    {category.title}{" "}
                  </Typography>
                </Box>
              </Box>
            </Card>
          ))}
        </Box>

        {/* Overlapping Cards */}

        <Box className="bottom-container">
          {categorieslast.map((category) => (
            <Card className="categorys-card" title="">
              <Box className="image-container">
                <Icon
                  className="categorys-image"
                  src={category.image}
                  alt="Vision"
                />
                <Box className="text-overlay">
                  <Typography
                    variant="body1"
                    className="category-title"
                    padding={"10px"}
                  >
                    {category.title}{" "}
                  </Typography>
                </Box>
              </Box>
            </Card>
          ))}
        </Box>
      </Box>
      {/* mobile */}
      <Box className="about-section-container-responsive">
        {/* Background Section */}
        <Box className="background-content-responsive">
          <Box width={"100%"} padding={"20px"}>
            <Typography
              variant="h6"
              className="card-hadiing"
            >
              Industries We Serve{" "}
            </Typography>
            <Typography variant="body1" className="card-body">
              We offer consultancy services and human resource solutions in the
              following specialties.
            </Typography>
          </Box>
        </Box>
        {/* <Box className="main-overlap-card"> */}
        <Box className="left-container-responsive">
          {categories.map((category) => (
            <Card className="category1-card" title="">
              <Box className="image-container">
                <Icon
                  className="categorys-image"
                  src={category.image}
                  alt="Vision"
                />
                <Box className="text-overlay" >
                  <Typography variant="body1" className="category-title">
                  {category.title}{" "}
                  </Typography>
                </Box>
              </Box>
            </Card>
          ))}
        </Box>
        {/* </Box> */}
       
        {/* <Box className="center-container">
          {categoriesmid.map((category) => (
            <Card className="categorys-card" title="">
              <Box className="image-container">
                <Icon
                  className="categorys-image"
                  src={category.image}
                  alt="Vision"
                />
                <Box className="text-overlay">
                  <Typography variant="body1" className="category-title" padding={"10px"}>
                  {category.title}{" "}
                  </Typography>
                </Box>
              </Box>
            </Card>
          ))}
        </Box> */}

        {/* Overlapping Cards */}

        {/* <Box className="bottom-container">
          {categorieslast.map((category) => (
            <Card className="categorys-card" title="">
              <Box className="image-container">
                <Icon
                  className="categorys-image"
                  src={category.image}
                  alt="Vision"
                />
                <Box className="text-overlay">
                  <Typography variant="body1" className="category-title" padding={"10px"}>
                    {category.title}{" "}
                  </Typography>
                </Box>
              </Box>
            </Card>
          ))}
        </Box> */}
      </Box>
    </>
  );
};
